<script>
import { required } from 'vuelidate/lib/validators'

export default {
	props: {
		netinfo: {
			type: Object,
			required: true
		}
	},
	data() {
		return {

		}
	},
	methods: {

	}
}
</script>

<template>
	<div>
		<div class="custom-control">
			<b>Company:</b>&nbsp;{{ netinfo.company }}
		</div>
    <div class="custom-control">
      <b>Location:</b>&nbsp;{{ netinfo.location }}
    </div>
    <div class="custom-control">
      <b>VLAN:</b>&nbsp;{{ netinfo.vlan }}
    </div>
    <div class="custom-control">
      <b>Segment:</b>&nbsp;{{ netinfo.network }}
    </div>
	</div>
</template>

<style>
	.incident-status {
		width: 15%;
	}
	.incident-description {
		width: 35%;
	}
</style>